import { Component, h, Host, Prop } from '@stencil/core';

@Component({
  tag: 'envc-text-mit-image',
  styleUrl: 'envc-text-mit-image.scss',
  shadow: true
})
export class EnvcTextMitImage {
  @Prop() addClasses: string;
  @Prop() headline: string;

  private getClasses(): string {
    return `indention--none ${this.addClasses} has-links has-lists`;
  }

  render() {
    return (
      <Host class={this.getClasses()}>
        {
          (this.headline) && (
            <h2>{this.headline}</h2>
          )
        }

        <slot name={'image'}></slot>
        <slot name={'text'}></slot>
      </Host>
    );
  }
}
